import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { otherDeductionsDetailInputList1 } from '../../../common/data';
import { formatNumber } from '../../../common/Util';

import ItemTitleSection from '../../../components/ItemTitleSection';
import TextField from '../../../components/common/TextField';

import Typography from '../../../components/common/Typography';
import { getBankList } from '../../common/commonSlice';

// 연금저축
const Type1 = ({ handleAddButton }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const [dataList, setDataList] = useState([{}]);
  const { s11_1Data } = useSelector(state => state.otherDeductions);
  const { bankList } = useSelector(state => state.common);
  const inputFields = otherDeductionsDetailInputList1(t);

  useEffect(() => {
    if (bankList.length === 0) {
      dispatch(getBankList());
    }
  }, [bankList, dispatch]);

  const shouldRenderField = (field, savings) => {
    if (field.key === 'htm010') {
      return savings.htm001 === '8' || savings.htm001 === '9';
    }
    return true;
  };

  const renderField = (field, value) => {
    let fieldValue = field.isNumber ? formatNumber(value || '') : value?.trim() || '';

    let displayValue = fieldValue;
    if (field.input === 'selectBox') {
      let codeList = [...field?.options];

      if (field.key !== 'htm002') {
        const selectedOption = codeList.find(item => item.value === fieldValue);
        displayValue = selectedOption?.label || '';
      } else {
        const selectedBank = bankList.find(item => item.bankCd?.trim() === fieldValue);
        displayValue = selectedBank?.bankNm || '';
      }
    }

    return (
      <TextField
        label={field.label}
        value={displayValue}
        onChange={() => {}}
        size="small"
        disabled
      />
    );
  };

  return s11_1Data?.list?.length > 0 ? (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <ItemTitleSection
        title={t('detail.type1.title')}
        addButton={true}
        handleAddButton={handleAddButton}
      />

      {s11_1Data.list.map((savings, index) => (
        <div key={index} className="savings-item">
          <div className="displayFlexBetween" style={{ marginBottom: '16px' }}>
            <Typography variant="body2Bold">
              {t('detail.type1.title')}
              {index + 1}
            </Typography>
          </div>

          <div className="displayFlexColumn" style={{ gap: '16px' }}>
            {inputFields.map((field, fieldIndex) => {
              if (shouldRenderField(field, savings)) {
                return <div key={fieldIndex}>{renderField(field, savings[field.key])}</div>;
              }
              return null;
            })}
          </div>
        </div>
      ))}
    </div>
  ) : null;
};

export default Type1;
